import React, { useState, useEffect, useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Card, CardBody } from '@/shared/components/Card';
import toast from 'react-hot-toast';
import { CgDetailsMore, CgNotes } from 'react-icons/cg';
import { IoMdTime } from 'react-icons/io';
import { MdOutlineLunchDining, MdOutlineArticle, MdRestaurantMenu } from 'react-icons/md';
import { FaPeopleLine, FaMapLocationDot } from 'react-icons/fa6';
import { Button } from '@/shared/components/Button';
import MealCardForDetails from './MealCardForDetails';
import { Mealcontext } from '../../../../context/MealContext';
import LocationCard from './LocationCard';
import ImageGallery from './ImageGallery';
import { GlobalVarContext } from '../../../../context/GlobalVarContext';
import NewImageGallery from './NewImageGallery';
import { AuthContext } from '../../../../context/AuthContext';

const MealDetails = () => {
  const [mealData, setMealData] = useState(null);
  const [restaurantData, setRestaurantData] = useState(null);
  const [similarMeals, setSimilarMeals] = useState([]);
  const [imagesphoto, setImagesphoto] = useState([]);
  const { apiGlobal } = useContext(GlobalVarContext);
  const { currencyCode, countryId } = useContext(AuthContext);
  const { 
    resaurantDetailsId,
    refresh, 
    setclick,
    setActiveKey,
    setIsDetailsClick,
  } = useContext(Mealcontext);
  const [resId, setResId] = useState(null);

  const imgPath = `${apiGlobal}/images/meal/attachment/`;

  // Fetch meal data
  useEffect(() => {
    const fetchMeal = async () => {
      if (!resaurantDetailsId) {
        toast.error('resisnotfound');
        return;
      }

      const formData = new FormData();
      formData.append('id', resaurantDetailsId);
      formData.append('country_id', countryId);
      try {
        const url = `${apiGlobal}/meal_data_fetch.php`;
        const response = await fetch(url, {
          method: 'POST',
          body: formData,
        });
        const data = await response.json();

        if (data.status && data.message === 'Success') {
          setMealData(data.data[0]);
          setImagesphoto(data.data[0].attachment);
          setResId(data.data[0].restaurant_id);
        }
      } catch (e) {
        console.log(e.message);
      }
    };

    fetchMeal();
  }, [resaurantDetailsId, refresh]);

  // Fetch restaurant data when meal data is available
  useEffect(() => {
    if (mealData && mealData.restaurant_id) {
      const fetchRestaurantData = async () => {
         const formData = new FormData();
         formData.append('id', mealData.restaurant_id);
         formData.append('country_id', countryId);
        try {
          const url = `${apiGlobal}/restaurant_data_fetch.php`;
          const response = await fetch(url, {
            method: 'POST',
            body: formData,
          });
          const data = await response.json();

          if (data.status && data.message === 'Success') {
            setRestaurantData(data.data[0]);
          }
        } catch (e) {
          console.log(e.message);
        }
      };

      fetchRestaurantData();
    }
  }, [mealData]);

  useEffect(() => {
    if (!resId) return;

    const fetchSimilarMeal = async () => {
      const formData = new FormData();
      formData.append('restaurant_id', resId);
      formData.append('id', resaurantDetailsId);
      formData.append('country_id', countryId);
      try {
        const response = await fetch(`${apiGlobal}/meal_restaurant_fetch.php`, {
            method: 'POST',
            body: formData,
          });
        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }
        const data = await response.json();
        setSimilarMeals(data.data || []);
      } catch (e) {
        console.log(`Error: ${e.message}`);
      }
    };

    fetchSimilarMeal();
  }, [resId, resaurantDetailsId]);

  if (!mealData || !restaurantData) {
    return <div>Loading...</div>;
  }
  // console.log(mealData);

  // if (!mealData) {
  //   toast.error('No meal details found');
  //   return null;
  // }
  // if (!restaurantData) {
  //   toast.error('No restaurant details found');
  //   return null;
  // }

  const backHandler = () => {
    setActiveKey('1');
    setclick('searchSelect');
    setIsDetailsClick(false);
  };

  const mealMapping = {
    1: 'Breakfast',
    2: 'Snacks',
    3: 'Lunch',
    4: 'Dinner',
  };

  // Parse attachment images
  const parsedimages = imagesphoto ? JSON.parse(imagesphoto) : [];

  // console.log(similarMeals);

  return (
    <Container>
      <div style={{ float: 'right', marginRight: '20px' }}>
        <Button variant="primary" onClick={backHandler}>Back</Button>
      </div>

      <Row>
        <Col xs={12} md={12}>
          <Card>
            <CardBody>
              <div className="row">
                <div className="col-12 col-md-4">
                  <h1>{mealData.name}</h1>
                </div>
                <div className="col-12 col-md-4">
                  <div className="price d-flex">
                    <div className="card-body price d-flex align-items-center">
                      <h2 className="card-text me-2" style={{ color: 'red' }}>
                        {mealData.price} <h3 className="d-inline" style={{ fontSize: '0.75em' }}>{currencyCode}</h3>
                      </h2>
                      {/* <h2 className="card-text me-2" style={{ color: 'blue' }}>
                        {mealData.final_price} <h3 className="d-inline" style={{ fontSize: '0.75em' }}>AED</h3>
                      </h2> */}
                    </div>
                  </div>
                </div>
              </div>
            
              <div className="row mt-2">
                <h5><CgDetailsMore /> {mealData.description}</h5>
              </div>

              <div className="row mt-2">
                <div className="col-12 col-md-4">
                  <p><IoMdTime />:  {mealData.meal_offered
    ?.split(',')
    .map(mealId => mealMapping[mealId.trim()])
    .filter(Boolean) // Remove undefined or null values
    .join(', ') || 'N/A'}
                  </p>
                </div>
                <div className="col-12 col-md-4">
                  <p><MdOutlineLunchDining />: {mealData.cuisines}</p>
                </div>
                {/* <div className="col-12 col-md-4">
                <p><MdOutlineArticle />: {mealData.meal_type}</p>
              </div> */}
              </div>

              <div className="row mt-2">

                <div className="col-12 col-md-4">
                  <p>
                    <MdRestaurantMenu />: {mealData.meal_type}
                  </p>
                </div>
                <div className="col-12 col-md-4">
                  <p><FaPeopleLine />: {mealData.capacity}</p>
                </div>
                <div className="col-12 col-md-4">
                  <p>
                    <FaMapLocationDot />: {mealData.locations && mealData.locations.length > 0 
    ? mealData.locations
        .map(location => location.location_name?.trim()) // Get and trim location names
        .filter(Boolean) // Remove empty or invalid names
        .join(', ') // Join names with commas
    : 'No locations available'}
                  </p>
                </div>

              </div>
              <div className="row mt-4">
                <div className="col-12">
                  <h5><CgNotes /> Meal Items</h5> 
                  <div
                    className="table-responsive mt-2"
                    style={{ maxHeight: '250px', overflowY: 'auto' }}
                  >
                    <table className="table table-bordered responsive mt-2 ">
                      <thead className="bg-primary text-white">
                        <tr>
                          <th>Item Name</th>
                          <th>Description</th>
                        </tr>
                      </thead>
                      <tbody>
                        {JSON.parse(mealData.items || '[]').map((item, index) => (
                        // eslint-disable-next-line
                        <tr key={index}>
                          <td>{item?.name}</td>
                          <td>{item?.description}</td>
                        </tr>
        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <hr />
              <div className="row mt-2">
                {mealData.locations && mealData.locations.length > 0 ? (
    mealData.locations.map((location, index) => (
      // eslint-disable-next-line
      <div key={index} className="col-12 mb-3">
        <h3>Map View: {location?.location_name}</h3>
        <LocationCard latitude={location?.latitude} longitude={location?.longitude} />
      </div>
    ))
  ) : (
    <p>No locations available.</p>
  )}
              </div>
              

              <hr />
             



              <div className="row mt-4">
                <h2>Restaurant - {restaurantData.name}</h2>
              </div>

              <div className="row mt-2">
                <p><CgDetailsMore /> {restaurantData.description}</p>
              </div>

              <div className="row mt-2" style={{ display: 'flex', justifyContent: 'center' }}>
                {parsedimages.length > 0 ? <NewImageGallery parsedimages={parsedimages} /> : 'No images available'}
              </div>
              <hr />

              {/* <div className="container mt-4 px-4" style={{ border: '1px solid grey' }}>
              <div className="row g-4 justify-content-center">
                {parsedimages.length > 0 ? (
        parsedimages.map(image => (
          <div 
            key={image.logo_id} 
            className="col-12 col-sm-6 col-md-4 col-lg-3"
          >
            <div className="position-relative overflow-hidden 
            rounded-lg hover:scale-105 transition-transform duration-300 h-64"
            >
              <Image
                src={imgPath + image.file_name}
                alt="Image description"
                className="w-full h-full object-cover 
                rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300"
              />
              <div className="absolute inset-0 bg-black/0 hover:bg-black/10 transition-colors duration-300" />
            </div>
          </div>
        ))
      ) : (
        <div className="col-12 text-center p-8">
          <div className="bg-gray-50 rounded-lg p-8 shadow-sm">
            <p className="text-gray-500 text-lg">No images available.</p>
          </div>
        </div>
      )}
              </div>
            </div> */}

              {similarMeals.length > 0 ? (
                <div className="row mt-4">
                  <h2>Similar Meals</h2>
                  <div className="similarMeals">
                    {similarMeals.map(meal => (
                      <MealCardForDetails
                        key={meal.id}
                        id={meal.id}
                        mealname={meal.name}
                        restaurantid={meal.restaurant_id}
                        description={meal.description}
                        type={meal.meal_type}
                        price={meal.price}
                        finalprice={meal.final_price}
                        format={meal.meal_format}
                        image={meal.photo}
                        isVeg={meal.veg_non_veg}
                        mealOffereds={meal.meal_offered}
                        cuisine={meal.cuisines}
                        capacity={meal.capacity}
                        resName={meal.restaurant_name}
                      />
                    ))}
                  </div>
                </div>
              ) : <h6> No Similar Meal Found!</h6>}

              {/* <div className="row mt-4">
                <h2>
                  {similarMeals.length > 0 ? 'Similar Meals' : 'No similar meals available'}
                </h2>
              </div>

              <div className="similarMeals">
                {similarMeals.map(meal => (
                  <MealCardForDetails
                    key={meal.id}
                    id={meal.id}
                    mealname={meal.name}
                    restaurantid={meal.restaurant_id}
                    description={meal.description}
                    type={meal.meal_type}
                    price={meal.price}
                    finalprice={meal.final_price}
                    format={meal.meal_format}
                    image={meal.photo}
                    isVeg={meal.veg_non_veg}
                    mealOffereds={meal.meal_offered}
                    cuisine={meal.cuisines}
                    capacity={meal.capacity}
                    resName={meal.restaurant_name}
                  />
              ))}
              </div> */}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

MealDetails.propTypes = {
  // Add any prop validation if necessary
};

export default MealDetails;
